export const ARTEFACT_LINK_REGEX = /\[Artefact:\s*[^\]]*\]\(artefact:\/\/([^)]+)\)/g;

export interface ArtefactSegment {
  type: "markdown" | "artefact";
  text: string;
  artefactId?: string;
  key: string;
}

export const splitAtArtefactLinks = (content: string): ArtefactSegment[] => {
  const segments: ArtefactSegment[] = [];
  let lastIndex = 0;
  let lastArtefactId: string | null = null;
  const regex = new RegExp(ARTEFACT_LINK_REGEX.source, "g");
  let match;

  while ((match = regex.exec(content)) !== null) {
    if (match.index > lastIndex) {
      segments.push({
        type: "markdown",
        text: content.slice(lastIndex, match.index),
        key: lastArtefactId ? `md-after-${lastArtefactId}` : "md-start",
      });
    }
    const artefactId = match[1];
    segments.push({ type: "artefact", text: "", artefactId, key: `artefact-${artefactId}` });
    lastArtefactId = artefactId;
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < content.length) {
    segments.push({
      type: "markdown",
      text: content.slice(lastIndex),
      key: lastArtefactId ? `md-after-${lastArtefactId}` : "md-start",
    });
  }

  if (segments.length === 0) {
    segments.push({ type: "markdown", text: content, key: "md-start" });
  }

  return segments;
};
